<button
  *ngIf="isDebug && !isOpen"
  nxButton="emphasis small"
  class="form-debug--closed"
  type="button"
  (click)="toggleOpen()"
>
  <nx-icon name="bolt"></nx-icon>
  <span class="nx-form-debug__label">Form Debug</span>
</button>

<div *ngIf="isDebug && isOpen" class="form-debug">
  <div class="form-debug--modes">
    <button
      *ngFor="let button of modes"
      [nxButton]="button === mode ? 'primary small'  :  'secondary small'"
      class="nx-margin-right-2xs"
      type="button"
      (click)="changeMode(button)">{{button}}</button>
    <button
      nxButton="emphasis small"
      class="nx-margin-right-2xs"
      type="button"
      (click)="toggleOpen()">Close</button>
  </div>
  <div class="form-debug--fields">
    <button
      *ngFor="let control of controls"
      [nxButton]="control === selectedControl ? 'primary small'  :  'secondary small'"
      class="nx-margin-right-2xs"
      type="button"
      (click)="changeControl(control)">{{control || 'formGroup' }}</button>
  </div>
  <div class="form-debug--content">
    <code>
      <pre *ngIf="selectedControl">{{ formGroup.controls[selectedControl][mode] | json }}</pre>
      <pre *ngIf="!selectedControl">{{ formGroup[mode] | json }}</pre>
    </code>
  </div>
</div>
